"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.selectOneMessageTemplateMock = exports.selectOneProduct = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var R = _interopRequireWildcard(require("ramda"));

var _utils = require("@alycecom/utils");

var _constants = require("../../constants");

var _gift = require("./gift.actions");

var _gift2 = require("./gift.types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  gift: null,
  giftContact: [],
  giftSendingStatus: _constants.GIFT_REQUEST_STATUSES.IDLE,
  giftContactSyncStatus: _constants.GIFT_REQUEST_STATUSES.IDLE,
  isLoading: false,
  error: null,
  stepToEdit: null
};

var selectOneProduct = function selectOneProduct(gift) {
  if (gift.proposed_products.length === 1) {
    return {
      product_id: gift.proposed_products[0].id
    };
  }

  return {};
};

exports.selectOneProduct = selectOneProduct;

var selectOneMessageTemplateMock = function selectOneMessageTemplateMock(gift) {
  if (gift.message && gift.subject) {
    return {
      template: {}
    };
  }

  return {};
};

exports.selectOneMessageTemplateMock = selectOneMessageTemplateMock;
var transformGiftCampaign = R.compose((0, _utils.renameKeys)({
  research_flow: 'researchFlow'
}), R.evolve({
  settings: (0, _utils.renameKeys)({
    enterprise_budget: 'enterpriseBudget',
    choosing_option: 'choosingOption',
    message_subject: 'messageSubject'
  }),
  owner: (0, _utils.renameKeys)({
    full_name: 'fullName'
  })
}));
var transformGiftRecipient = R.applySpec({
  avatar: R.pathOr(null, ['research', 'image']),
  company: R.prop('company'),
  first_name: R.prop('firstName'),
  last_name: R.prop('lastName'),
  email: R.prop('email'),
  full_name: R.prop('fullName'),
  profile: R.applySpec({
    research_tags: R.pathOr([], ['research', 'researchTags'])
  })
});

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _gift2.GIFT_CREATE_CLEAR_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: R.set(R.lensPath(action.payload), null, state.error)
      });

    case _gift2.GIFT_SET_SEND_AS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case _gift2.GIFT_CREATE_SEND_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        giftSendingStatus: _constants.GIFT_REQUEST_STATUSES.LOADING
      });

    case _gift2.GIFT_SET_GIFT_ACTIONS_REQUEST:
    case _gift2.GIFT_CREATE_SEND_REQUEST:
    case _gift2.GIFT_CREATE_LOAD_REQUEST:
    case _gift2.GIFT_REFRESH_LOAD_REQUEST:
    case _gift2.GIFT_CREATE_REQUEST:
    case _gift2.GIFT_CREATE_SELECT_PRODUCT:
    case _gift2.GIFT_SET_VIDEO_MESSAGE_REQUEST:
    case _gift2.SET_FULL_RESEARCH.REQUEST:
    case _gift2.GIFT_EXPIRE_REQUEST:
    case _gift.giftUnexpire.pending.getType():
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        isLoading: true
      });

    case _gift2.GIFT_VERIFY_AVAILABLE_CONTACT_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        giftContact: initialState.giftContact,
        giftContactSyncStatus: _constants.GIFT_REQUEST_STATUSES.LOADING
      });

    case _gift2.GIFT_CREATE_LOAD_SUCCESS:
    case _gift2.GIFT_REFRESH_LOAD_SUCCESS:
    case _gift2.GIFT_SET_GIFT_ACTIONS_SUCCESS:
    case _gift2.GIFT_CREATE_SUCCESS:
    case _gift2.SET_FULL_RESEARCH.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        stepToEdit: null,
        isLoading: false,
        gift: _objectSpread(_objectSpread(_objectSpread({}, action.payload), selectOneMessageTemplateMock(action.payload)), {}, {
          recipient: transformGiftRecipient(action.payload.recipient),
          campaign: transformGiftCampaign(action.payload.campaign)
        })
      });

    case _gift2.GIFT_CREATE_SEND_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        stepToEdit: null,
        isLoading: false,
        giftSendingStatus: _constants.GIFT_REQUEST_STATUSES.COMPLETED,
        gift: _objectSpread(_objectSpread({}, state.gift), {}, {
          status_id: action.payload.statusId,
          status_label: action.payload.statusLabel || state.status_label,
          scheduled_at: action.payload.scheduledAt || state.scheduled_at,
          recipient_landing_page: action.payload.recipientLandingPage || state.recipient_landing_page
        })
      });

    case _gift2.GIFT_EXPIRE_SUCCESS:
    case _gift2.GIFT_CANCEL_SUCCESS:
    case _gift.giftUnexpire.fulfilled.getType():
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        stepToEdit: null,
        isLoading: false,
        gift: _objectSpread(_objectSpread({}, state.gift), {}, {
          status_id: action.payload.statusId,
          status_label: action.payload.statusLabel || state.status_label
        })
      });

    case _gift2.GIFT_SET_SEND_AS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        gift: _objectSpread(_objectSpread({}, state.gift), {}, {
          sender: action.payload.sender,
          send_as_user_id: action.payload.send_as_user_id,
          send_as: action.payload.send_as,
          email_provider: action.payload.email_provider,
          recipient: transformGiftRecipient(action.payload.recipient)
        })
      });

    case _gift2.GIFT_CREATE_FAIL:
    case _gift2.GIFT_CREATE_SEND_FAIL:
    case _gift2.GIFT_CREATE_LOAD_FAIL:
    case _gift2.GIFT_REFRESH_LOAD_FAIL:
    case _gift2.GIFT_SET_GIFT_ACTIONS_FAIL:
    case _gift2.GIFT_SET_SEND_AS_FAIL:
    case _gift2.GIFT_SET_VIDEO_MESSAGE_FAIL:
    case _gift2.SET_FULL_RESEARCH.FAIL:
    case _gift2.GIFT_EXPIRE_FAIL:
    case _gift2.GIFT_CANCEL_FAIL:
    case _gift2.GIFT_VERIFY_AVAILABLE_CONTACT_FAILED:
    case _gift.giftUnexpire.rejected.getType():
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload,
        isLoading: false,
        giftContact: initialState.giftContact,
        giftContactSyncStatus: _constants.GIFT_REQUEST_STATUSES.COMPLETED
      });

    case _gift2.GIFT_CREATE_SEND_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        giftSendingStatus: _constants.GIFT_REQUEST_STATUSES.COMPLETED
      });

    case _gift2.GIFT_VERIFY_AVAILABLE_CONTACT_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        giftContactSyncStatus: initialState.giftContactSyncStatus
      });

    case _gift2.GIFT_CREATE_SEND_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        giftSendingStatus: initialState.giftSendingStatus
      });

    case _gift2.GIFT_CREATE_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        gift: null,
        stepToEdit: null,
        giftContact: initialState.giftContact,
        giftSendingStatus: initialState.giftSendingStatus,
        giftContactSyncStatus: initialState.giftContactSyncStatus
      });

    case _gift2.GIFT_DISCARD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        gift: _objectSpread(_objectSpread({}, state.gift), {}, {
          status_id: 100
        })
      });

    case _gift2.GIFT_SET_VIDEO_MESSAGE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        gift: _objectSpread(_objectSpread({}, state.gift), {}, {
          recipient_video: action.payload.recipient_video,
          recipient: transformGiftRecipient(action.payload.recipient)
        }),
        stepToEdit: null
      });

    case _gift2.GIFT_CREATE_SELECT_TEMPLATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        gift: _objectSpread(_objectSpread({}, state.gift), {}, {
          template: action.payload,
          message: null,
          subject: null,
          is_ready_to_be_sent: false
        }),
        stepToEdit: null,
        error: null
      });

    case _gift2.GIFT_SET_PRODUCT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        gift: _objectSpread(_objectSpread(_objectSpread({}, state.gift), action.payload), {}, {
          message: null,
          subject: null,
          campaign: transformGiftCampaign(action.payload.campaign),
          recipient: transformGiftRecipient(action.payload.recipient)
        }),
        stepToEdit: null
      });

    case _gift2.GIFT_VERIFY_AVAILABLE_CONTACT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        giftContact: action.payload,
        giftContactSyncStatus: _constants.GIFT_REQUEST_STATUSES.COMPLETED
      });

    case _gift2.GIFT_CREATE_EDIT_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        stepToEdit: action.payload
      });

    case _gift2.GIFT_SET_PRODUCT_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload,
        stepToEdit: _constants.steps.SELECT_PRODUCT
      });

    case _gift2.SAVE_GIFT_VIDEO_MESSAGE_CLEAN_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload
      });

    case _gift2.GIFT_SALES_INTEGRATIONS_RESET:
      return _objectSpread({}, initialState);

    default:
      return state;
  }
};

exports.reducer = reducer;